import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

interface updateLocationGroupInterface {
  id: string;
  name: string | unknown;
}

export const useUpdateLocationGroup = () => {
  return useMutation({
    mutationFn: updateLocationGroup,
    onSuccess: (data, payload) => {
      if (payload) {
        queryClient.invalidateQueries(queryKeys.locationGroups.invalidateAll());
        queryClient.invalidateQueries(queryKeys.viewLocations.all('all'));
        queryClient.invalidateQueries(
          queryKeys.getLocationGroupsWithLocationCount.pagination(),
        );
      }
    },
  });
};

const updateLocationGroup = async (payload: updateLocationGroupInterface) => {
  let locationGroupData = { name: payload.name };
  const response = await requestCCApi({
    url: `/locationGroups/${payload.id}`,
    method: 'PATCH',
    data: {
      data: locationGroupData,
    },
  });

  return response.data;
};
